import { z } from 'zod'

export const receiptSearchSchema = z
  .object({
    revisionNumber: z.number().int().positive().optional(),
    ids: z
      .array(z.number().int().positive())
      .min(1)
      .max(100)
      .refine((ids) => new Set(ids).size === ids.length, '账单组不能重复')
  })
  .refine((v) => !v.revisionNumber || v.ids.length === 1, '历史版本只能选择一个收款单')
